import { FileText, Building2, Database } from 'lucide-react';
import { routesMap } from '../../routes/routesMap';
import HeroSection from '../../components/conduct-risk/HeroSection';
import ModuleCard from '../../components/ui/ModuleCard';

const BEST_EXECUTION_CARDS = [
  {
    title: 'Report Best Execution',
    description: 'In questa sezione è possibile visualizzare la lista dei report.',
    link: routesMap.REPORT_PAGE,
    icon: FileText,
    label: 'Sezione',
  },
  {
    title: 'Banche e fonti dati',
    description: 'Gestisci e visualizza le fonti relative alle banche.',
    link: routesMap.BANKS_PAGE,
    icon: Building2,
    label: 'Sezione',
  },
  {
    title: 'Altre fonti dati',
    description: 'Visualizza e gestisci le altre fonti dati.',
    link: routesMap.ALTRE_FONTI,
    icon: Database,
    label: 'Sezione',
  },
];

const BestExecutionHomePage = () => {
  return (
    <div className="flex flex-col bg-gray-50">
      <HeroSection
        title="Best Execution"
        description="Accedi ai report, esplora i dati delle banche e gestisci le fonti."
        breadcrumbLinks={[
          { url: routesMap.HOME_PAGE, title: 'Home' },
          { url: '#', title: 'Best Execution' },
        ]}
      />

      <div className="flex-1 px-8 lg:px-16 py-12 w-full">
        <h2 className="text-2xl font-bold mb-2 font-heading" style={{ color: '#1B365D' }}>
          I tuoi strumenti
        </h2>
        <p className="text-gray-500 mb-8 font-paragraph">
          Seleziona la sezione a cui vuoi accedere.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {BEST_EXECUTION_CARDS.map((card, i) => (
            <ModuleCard key={i} {...card} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BestExecutionHomePage;
